var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"m-0 small text-lowercase"},[_vm._v(_vm._s(_vm.days)+"d "+_vm._s(_vm.hours)+"h "+_vm._s(_vm.minutes)+"m "+_vm._s(_vm.seconds)+"s")])
}
var staticRenderFns = []

export { render, staticRenderFns }